import { nanoid } from 'nanoid';

export function generateGrievanceReference() {
  const date = new Date();
  const year = date.getFullYear().toString().slice(-2);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const uniqueId = nanoid(4).toUpperCase();
  
  return `NMS-${year}${month}-${uniqueId}`;
}